/**
 * defa.views.SupportResponseFunctionalityView
 * Functionality buttons for an individual SupportResponse.
 * @version 1.2.0
 */

import View     from 'scripts/poppet/view';
import template from 'templates/supportResponseFunctionalityView.jst.html';

const channelNav = Bb.Radio.channel( 'nav' );

const selectors                        = {
	buttonInstalled: '[data-click=functionality-installed]',
	buttonLog      : '[data-click=functionality-log]',
	buttonInvoices : '[data-click=functionality-invoices]',
	buttonMigrate  : '[data-click=functionality-migrate]',
};
const SupportResponseFunctionalityView = View.extend( {
	
	// ------------------------------------------------
	// Setup
	// ------------------------------------------------
	
	template : template,
	tagName  : 'nav',
	className: 'response-functionality-menu',
	
	ui: {
		installed: selectors.buttonInstalled,
		invoices : selectors.buttonInvoices,
		log      : selectors.buttonLog,
		migrate  : selectors.buttonMigrate,
	},
	
	events: {
		'click @ui.installed': 'onClickInstalled',
		'click @ui.log'      : 'onClickLog',
		'click @ui.invoices' : 'onClickInvoices',
		'click @ui.migrate'  : 'onClickMigrate',
	},
	
	templateContext: function () {
		return {
			isCustomer : this.isCustomer(),
			isInstaller: this.isInstaller(),
			isUnit     : this.isUnit(),
			isUser     : this.isUser(),
			isVisible  : this.isVisible(),
		};
	},
	
	
	// ------------------------------------------------
	// Event Handlers
	// ------------------------------------------------
	
	/**
	 * Triggers before the view is rendered.
	 * @void
	 */
	onRender: function () {
		
		if ( !this.isVisible() ) {
			this.$el.prop( 'hidden', true );
		}
	},
	
	/**
	 * Triggers when the end user clicks the log button.
	 * @param {event} event  The click event.
	 * @void
	 */
	onClickLog: function ( event ) {
		
		event.preventDefault();
		
		let id   = this.model.get( 'bid' ),
			type = this.getModelType();
		
		channelNav.trigger( 'log', [ type, id, 1, ] );
	},
	
	/**
	 * Triggers when the end user clicks the invoices button.
	 * @param {event} event  The click event.
	 * @void
	 */
	onClickInvoices: function ( event ) {
		
		event.preventDefault();
		let id = this.model.get( 'bid' );
		
		channelNav.trigger( 'customer:invoices', [ id, ] );
	},
	
	/**
	 * Triggers when the end user clicks the installed button.
	 * @param {event} event  The click event.
	 * @void
	 */
	onClickInstalled: function ( event ) {
		
		event.preventDefault();
		this.trigger( 'installed', this );
	},
	
	/**
	 * Triggers when the end user clicks the migrate button.
	 * @param {event} event  The click event.
	 * @void
	 */
	onClickMigrate: function ( event ) {
		
		event.preventDefault();
		this.trigger( 'migrate', this );
	},
	
	
	// ------------------------------------------------
	// Other functions
	// ------------------------------------------------
	
	/**
	 * Gets the url-friendly name of the model.
	 * @return {string}  The url friendly name of the model.
	 */
	getModelType: function () {
		
		let type;
		
		switch ( this.model.get( 'class' ) ) {
			
			case 'CUSTOMER'  :
			case 'INSTALLER' :
				type = 'billing';
				break;
			
			case 'USER' :
				type = 'user';
				break;
			
			case 'UNIT' :
			default     :
				type = 'device';
				break;
		}
		
		return type;
		
	},
	
	/**
	 * Checks if this snippet's model is a customer.
	 * @return {bool} True if this model is a customer, false if not.
	 */
	isCustomer: function () {
		let classes = [ 'CUSTOMER', 'INSTALLER', ];
		
		return _.contains( classes, this.model.get( 'class' ) );
	},
	
	/**
	 * Checks if this snippet's model is an installer customer.
	 * @return {bool} True if this model is an installer, false if not.
	 */
	isInstaller: function () {
		return ( 'INSTALLER' === this.model.get( 'class' ) );
	},
	
	/**
	 * Checks if this snippet's model is a unit.
	 * @return {bool} True if this model is a unit, false if not.
	 */
	isUnit: function () {
		return ( 'UNIT' === this.model.get( 'class' ) );
	},
	
	/**
	 * Checks if this snippet's model is a User.
	 * @return {bool} True if this model is a user, false if not.
	 */
	isUser: function () {
		return ( 'USER' === this.model.get( 'class' ) );
	},
	
	/**
	 * Checks if this functionality view should be visible
	 * @return {bool} True if this view should be visible, false if not.
	 */
	isVisible: function () {
		let classes = [ 'CUSTOMER', 'INSTALLER', 'UNIT', 'USER', ];
		
		return _.contains( classes, this.model.get( 'class' ) );
	},
	
} );

export default SupportResponseFunctionalityView;